export default "__VITE_ASSET__75TdL82t__"